const { forEachElement } = require('../../common/utils/dom');

const isMatchMedia = (maxWidth) =>
  window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
const bpFigure = 768;
const desktopEvents = ['mousemove', 'mousedown', 'scroll'];
const videoStopEvents = ['pause', 'ended'];
const videoPlayEvents = ['play', 'playing'];
const videoPlayingClass = 'video-playing';

const options = {
  timeToStart: 2000,
  timeInterval: 1000,
  iconHeight: '50px',
  iconHeightDesktop: '50px',
  maxIconsOnSceen: 50,
  maxIconsOnSceenDesktop: 100,
  iconsNumber: '7',
  iconsFolderAbs: {},
};

let bpType = null;
let desktopEventListeners = null;
let mouseUpListener = null;
let touchStartListener = null;
let touchEndListener = null;
let timer = null;
let maxImages = null;
let iconHeight = null;
let divContainer = null;
let drawingInterval = null;

window.onload = () => {
  initContainer();
  if (options.iconsNumber > 0) {
    handleWindowEvents();
    handleVideoEvents();
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    window.addEventListener('resize', handleWindowEvents);
  }
};

function getParamsFromDivContainer() {
  Object.assign(options, divContainer.dataset);
  options.timeToStart = parseInt(options.timeToStart, 10);
  options.timeInterval = parseInt(options.timeInterval, 10);
  options.iconsFolderAbs = JSON.parse(options.iconsFolderAbs);
  options.iconsNumber = Object.keys(options.iconsFolderAbs).length;
  options.maxIconsOnSceen = parseInt(options.maxIconsOnSceen, 10);
  options.maxIconsOnSceenDesktop = parseInt(options.maxIconsOnSceenDesktop, 10);
  options.iconHeight = parseInt(options.iconHeight.split('px')[0], 10);
  options.iconHeightDesktop = parseInt(
    options.iconHeightDesktop.split('px')[0],
    10
  );
}

function initContainer() {
  divContainer = document.querySelector('.the-home-icons-flow');
  getParamsFromDivContainer();
}

function handleWindowEvents() {
  bpType = isMatchMedia(bpFigure) ? 'mobile' : 'desktop';
  if (!desktopEventListeners) {
    desktopEventListeners = [];
    desktopEvents.forEach((e) => {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener
      window.addEventListener(e, resetContainer);
      desktopEventListeners.push(e);
    });
  }
  if (!mouseUpListener) {
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    mouseUpListener = window.addEventListener('mouseup', startDrawing);
  }
  if (bpType === 'mobile') {
    if (!touchStartListener) {
      touchStartListener = window.addEventListener(
        'touchstart',
        resetContainer
      );
    }
    if (!touchEndListener) {
      touchEndListener = window.addEventListener('touchend', startDrawing);
    }
    maxImages = options.maxIconsOnSceen;
    iconHeight = options.iconHeight;
  } else {
    removeMobileListeners();
    maxImages = options.maxIconsOnSceenDesktop;
    iconHeight = options.iconHeightDesktop;
  }
  resetContainer();
}

function handleVideoEvents() {
  forEachElement(document.querySelectorAll('video'), (video) => {
    videoStopEvents.forEach((e) => {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener
      video.addEventListener(e, handleVideoStop);
    });
    videoPlayEvents.forEach((e) => {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener
      video.addEventListener(e, handleVideoPlay);
    });
  });
}

function resetContainer() {
  if (divContainer) divContainer.innerHTML = '';
  startDrawing();
}

function startDrawing() {
  if (!document.querySelector(`.${videoPlayingClass}`)) {
    clearTimeout(timer);
    clearInterval(drawingInterval);
    timer = setTimeout(drawImage, options.timeToStart);
  }
}

function handleVideoPlay(e) {
  clearTimeout(timer);
  clearInterval(drawingInterval);
  if (divContainer) divContainer.innerHTML = '';
  if (!e.target.classList.contains(videoPlayingClass)) {
    e.target.classList.add(videoPlayingClass);
  }
}

function handleVideoStop(e) {
  if (e.target.classList.contains(videoPlayingClass)) {
    e.target.classList.remove(videoPlayingClass);
  }
  startDrawing();
}

function removeMobileListeners() {
  if (touchStartListener) {
    touchStartListener = null;
    window.removeEventListener('touchstart', resetContainer);
  }
  if (touchEndListener) {
    touchEndListener = null;
    window.removeEventListener('touchend', startDrawing);
  }
}

function getRandom(max, min = 0) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function drawImage() {
  clearInterval(drawingInterval);
  drawingInterval = window.setInterval(() => {
    if (divContainer.childElementCount >= maxImages) {
      divContainer.removeChild(divContainer.firstElementChild);
    }
    const x = getRandom(divContainer.offsetWidth - 50);
    const y = getRandom(divContainer.offsetHeight - iconHeight);
    const randomIconNumber = getRandom(options.iconsNumber - 1).toString();
    const imgSrc =
      options.iconsFolderAbs[
        Object.keys(options.iconsFolderAbs)[randomIconNumber]
      ];

    const imgElement = document.createElement('img');
    imgElement.setAttribute('alt', '');
    imgElement.classList.add('icon');
    imgElement.setAttribute('src', imgSrc);
    imgElement.style.cssText = `height: ${iconHeight}px; left:${x}px; top:${y}px;`;
    divContainer.append(imgElement);
  }, options.timeInterval);
}
